import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { SecondaryButton } from '../../../components/button';
import styles from './cookies_banner.module.scss';

type Props = {
  onValid: Function;
};

export const CookiesBanner: FC<Props> = ({ onValid }) => {
  const [isDisplayed, setDisplayed] = useState(true);

  const onClick = () => {
    setDisplayed(false);
    onValid(() => {
      doctrineAnalytics('Account CookieBannerClosed');
    });
  };

  if (!isDisplayed) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.container}>
        <p className={styles.message}>
          <FormattedMessage
            id="CookiesBanner.tsx/1"
            values={{
              edit: (msg: string) => (
                <Hyperlink
                  className={styles.link}
                  href="/cookies"
                  source="cookies-banner-edit"
                  data-snapshot="disable-href"
                >
                  {msg}
                </Hyperlink>
              ),
              page: (msg: string) => (
                <Hyperlink
                  className={styles.link}
                  href="/cookies"
                  source="cookies-banner-page"
                  data-snapshot="disable-href"
                >
                  {msg}
                </Hyperlink>
              ),
            }}
          />
        </p>
        <div className={styles.actions}>
          <SecondaryButton type="button" onClick={onClick}>
            <FormattedMessage id="CookiesBanner.tsx/6" />
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
};
